import axios from '@/libs/api.request'

export const getSCMAttributes = (componentType, id) => {
  return axios.request({
    url: `/parts/${componentType}/${id}/scm-attributes`,
    method: 'get'
  })
}

export const getLastPurchase = (componentType, id) => {
  return axios.request({
    url: `/parts/${componentType}/${id}/last-purchase`,
    method: 'get'
  })
}
export const getPriceTable = (costId, lineItemId) => {
  return axios.request({
    url: `/pricing/${costId}/items/${lineItemId}/suggestion`,
    method: 'get'
  })
}
